import * as colors from 'components/common/colorConstants';
import styled from 'styled-components/macro';
import { smallScreens, lowHeightScreens } from '../../../common/fontElements';

export const SelectionPath = styled.div`
  list-style: none;
  overflow: hidden;
  font: 9px Sans-Serif;
  display: flex;
  flex-wrap: wrap;
`;

export const SelectionPathContainer = styled.div`
  padding: 10px 0px 10px 20px;
  background-color: ${colors.darkWhite1};
  border-top: 10px solid white;
  display: flex;
  align-items: center;
  border-top: 1px solid ${colors.lightGray6};
  border-bottom: 1px solid ${colors.lightGray6};
`;

export const HouseIcon = styled.img`
  &:hover {
    cursor: pointer;
  }
  height: 100%;
  margin-top: 4px;
  align-self: flex-start;
`;

export const SelectionPathSection = styled.div`
  height: 20px;
  cursor: ${(props) => (props.link ? 'pointer' : 'auto')};
  display: flex;
  align-items: center;

  img {
    position: relative;
    top: 1px;
  }
`;

export const SelectionPathText = styled.span`
  color: ${(props) => (props.link ? colors.darkGray1 : colors.lightBlack)};
  font-size: 10px;
  font-weight: ${(props) => (props.link ? '500' : '700')};
  text-decoration: none;
  padding: 5px 15px 4px 15px;
  position: relative;
  display: inline-block;
  white-space: nowrap;
  text-align: left;
  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 8px;
    padding: 4px 12px 3px 12px;
  }
`;
